module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block",
      "overflow": "hidden",
      "margin": "10px 0"
    }
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": 'static/images/products/' + _vm.item.code + '.jpg',
      "alt": _vm.item.name
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-center"
  }, [_c('button', {
    on: {
      "click": _vm.minq
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background": "transparent",
      "border": "2px solid #ccc"
    },
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.counter))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addq
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 text-right"
  }, [_vm._v("\n\t\tPhp " + _vm._s(_vm.formatMoney(_vm.iteminfo.total)) + "\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 text-right"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "title": "removeitem"
    },
    on: {
      "click": _vm.removeitem
    }
  }, [_vm._v("Remove Item")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2b522fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Item.vue
// module id = 164
// module chunks = 0